{
  "app": { "title": "85AI 財務及會計系統" },
  "tab": { "aria": "主導航" },
  "nav": { "home": "首頁", "capture": "記帳", "list": "紀錄", "reports": "報表", "more": "更多", "back": "返回" },
  "more": { "heading": "更多", "settings": "設定", "evidence": "憑證總覽" },
  "settings": { "heading": "設定", "font": "字級", "font_std": "標準", "font_lg": "大", "font_xl": "特大", "font_note": "調大字級令閱讀更清楚（只影響你部機）。", "language": "語言" },
  "proof": { "heading": "憑證", "camera": "影相", "file": "上載檔案／PDF", "uploading": "上載中…", "hint": "影相或上載單據 —— 會計師同管理層會靠呢啲材料。" },
  "evidence": { "heading": "憑證總覽", "search": "搜尋", "search_hint": "用途／單號／對象", "count": "{{files}} 張憑證 · {{vouchers}} 張憑單", "empty": "冇憑證（試下改篩選）" },
  "auth": {
    "heading": "登入",
    "phone": "電話號碼",
    "pin": "密碼（PIN）",
    "sign_in": "登入",
    "signing_in": "登入中…",
    "sign_out": "登出",
    "failed": "電話或密碼不正確"
  },
  "changepin": {
    "heading": "設定新 PIN",
    "note": "第一次登入必須改 PIN（臨時 PIN 唔可以繼續用）。新 PIN 最少 6 個字元。",
    "current": "現有 PIN（臨時）",
    "new": "新 PIN",
    "confirm": "再輸入新 PIN",
    "save": "確認更改",
    "saving": "儲存中…",
    "mismatch": "兩次輸入嘅新 PIN 唔一致"
  },
  "home": {
    "net": "本月結餘",
    "todo": "待辦",
    "todo_none": "冇待辦 🎉",
    "heading": "首頁",
    "entity": "公司",
    "expense": "本月支出",
    "income": "本月收入",
    "period": "期間：{{period}}",
    "pending_reimb": "代墊待補回：{{n}} 筆",
    "capture_cta": "影相記帳",
    "income_cta": "記收入",
    "recent": "最近紀錄",
    "list_cta": "全部紀錄",
    "report_cta": "月報",
    "export_cta": "匯出",
    "periods_cta": "鎖帳／審計",
    "profit_cta": "分配試算",
    "budget_cta": "預算對照",
    "items_cta": "應收應付",
    "bank_cta": "銀行對帳",
    "assets_cta": "固定資產"
  },
  "capture": {
    "heading": "影相記帳",
    "open_camera": "開相機",
    "pick_file": "揀相／PDF",
    "shoot": "影相",
    "flip": "前後鏡",
    "cancel": "取消",
    "retake": "再影",
    "uploaded": "已上載 {{kb}} KB（原件存喺私密儲存）",
    "saved": "✅ 已記錄：{{no}}",
    "back_home": "返首頁",
    "working": "處理中…",
    "working_ocr": "OCR 讀緊…",
    "failed": "影相失敗，請再試",
    "denied": "開唔到相機（{{msg}}）—— 可以用「揀相」",
    "upload_failed": "上載失敗：{{msg}}",
    "guide": "對準單據放入框內，篤一下畫面可鎖焦",
    "detected": "偵測到單據 —— 保持不動（自動拍攝）",
    "auto": "自動拍攝：開／關",
    "opening": "開啟相機中…",
    "hold": "見到單據 —— 保持不動",
    "scan_error": "偵測出錯：{{msg}}",
    "manual_hint": "影相＝個框；撳 🤖 可自動搵單據並自動拍",
    "adjust_hint": "拉四個角對準單據四邊，再撳「拉平使用」",
    "apply": "拉平使用"
  },
  "ocr": {
    "heading": "OCR 自動填表",
    "reading": "讀緊收據…（大約 3–10 秒）",
    "done": "讀完（{{ms}} 毫秒、約 {{neurons}} neurons）",
    "failed": "OCR 失敗：{{msg}} —— 照樣可以人手填完再儲存",
    "machine_hint": "🤖 有呢個標記嘅欄位係**機器讀**，儲存前請核對一次（尤其金額同日期）。",
    "show_raw": "睇 OCR 原文",
    "hide_raw": "收埋原文"
  },
  "expense": {
    "amount": "金額（HK$）",
    "date": "日期",
    "category": "類別",
    "purpose": "用途",
    "purpose_hint": "例：的士去 JHC 開會",
    "supplier": "供應商／收款人",
    "supplier_hint": "打字會自動提示（新名可以即場建立）",
    "entity": "公司",
    "paid_by": "邊個付錢",
    "paid_by_simon": "Simon（個人代墊）",
    "paid_by_raymond": "Raymond（個人代墊）",
    "paid_by_company": "公司",
    "payment_method": "付款方式",
    "account": "付款戶口",
    "project": "項目",
    "save": "儲存憑單"
  },
  "method": {
    "cash": "現金",
    "bank_transfer": "銀行轉帳",
    "fps": "轉數快 FPS",
    "cheque": "支票",
    "credit_card": "信用卡",
    "debit_card": "扣帳卡",
    "ewallet": "電子錢包",
    "auto_debit": "自動轉帳",
    "none": "不適用"
  },
  "income": {
    "heading": "記收入",
    "category": "收入類別",
    "account": "收款戶口",
    "entity": "公司",
    "customer": "客戶／來源名稱",
    "customer_hint": "例：JHC／Roadshow 名／B2B 客戶",
    "doc_no": "發票／單據號",
    "attach": "附上發票／入數紙",
    "attached": "已附上 1 個檔案",
    "save": "儲存收入"
  },
  "items": {
    "heading": "應收／應付（AR/AP）",
    "kind": "類型",
    "kind_ar": "應收（客戶欠我哋）",
    "kind_ap": "應付（我哋欠供應商）",
    "party": "客戶／供應商",
    "issue_date": "開單日",
    "due_date": "到期日",
    "amount": "金額（HK$）",
    "income_code": "收入科目",
    "expense_code": "費用科目",
    "create_ar": "開應收單（出 JV 憑單）",
    "create_ap": "開應付單（出 JV 憑單）",
    "note": "開單會即時出一張憑單（AR：Dr 應收/Cr 收入；AP：Dr 費用/Cr 應付）→ 帳目同報表即時正確；之後收款／付款再出一張憑單結算。",
    "created": "✅ 已開單，憑單：{{no}}",
    "settled": "✅ 已結算，憑單：{{no}}（未結餘額 {{balance}}）",
    "settle_amount_needed": "請輸入今次收款／付款金額",
    "account_needed": "請揀收款／付款戶口",
    "open_list": "未結清項目",
    "settle_account": "收款／付款戶口",
    "due": "到期 {{date}}",
    "settle_amount": "今次金額",
    "receive": "收款",
    "pay": "付款",
    "aging": "帳齡分析（按到期日）",
    "current": "未到期",
    "balance": "未結餘額",
    "total": "合計"
  },
  "budget": {
    "heading": "預算 vs 實際",
    "expense_budget": "支出預算",
    "expense_actual": "支出實際",
    "income_budget": "收入預算",
    "income_actual": "收入實際",
    "budget": "預算（HK$）",
    "actual": "實際",
    "variance": "差異",
    "save": "儲存預算",
    "saved": "✅ 已更新 {{n}} 行預算（已留審計）",
    "note": "預算係規劃數據（可以改，每次改動留審計）；實際數字一律由分錄計，同月報一致。",
    "unbudgeted": "冇預算但有實際",
    "bad_amount": "金額格式唔啱：{{v}}（最多 2 位小數）",
    "no_changes": "冇改過任何行"
  },
  "list": {
    "heading": "交易紀錄",
    "back_home": "返首頁",
    "month": "月份",
    "kind": "類型",
    "all": "全部",
    "kind_payment": "支出",
    "kind_receipt": "收入",
    "search": "搜尋",
    "search_hint": "用途／單號／供應商",
    "loading": "載入中…",
    "count": "共 {{n}} 筆",
    "empty": "暫時未有紀錄",
    "net": "淨額 {{amount}}",
    "pending_reimb": "待補回"
  },
  "detail": {
    "back": "返清單",
    "amount": "金額",
    "status": "狀態",
    "status_confirmed": "已確認",
    "status_draft": "草稿",
    "status_locked": "已鎖帳",
    "status_voided": "已沖銷",
    "lines": "分錄（借／貸）",
    "gl": "科目",
    "dr": "借 Dr",
    "cr": "貸 Cr",
    "balanced": "Σ借 = Σ貸（由 DB 強制，唔平寫唔入）",
    "attachments": "附件（{{n}}）",
    "no_attachment": "冇附件",
    "ocr_meta": "模型：{{model}}｜信心：{{confidence}}",
    "raw_note": "OCR 原文（逐行文字）同完整 JSON 存放喺 DB `ocr_extractions`（可審計）。",
    "void_heading": "紅字沖銷",
    "void_reason": "沖銷原因",
    "void_reason_hint": "例：供應商開錯金額／重複入帳",
    "void_cta": "確認沖銷（出紅字單）",
    "void_note": "沖銷**唔會刪除**原單：原單標「已沖銷」，另外出一張反向分錄嘅沖銷單（兩邊都保留，可審計）。",
    "void_already": "呢張單已經沖銷（唔准再沖；要更正請開新單）",
    "void_done": "已沖銷，沖銷單：{{no}}",
    "open_reversal": "打開沖銷單",
    "voided_by": "已被沖銷（沖銷單）",
    "reversal_of": "沖銷單（原單）"
  },
  "periods": {
    "heading": "會計期間／月結鎖帳",
    "status": "狀態",
    "locked": "已鎖帳",
    "open": "開放",
    "locked_at": "鎖帳時間",
    "lock": "鎖帳",
    "unlock": "解鎖",
    "empty": "暫時未有期間（入第一張單就會自動開）",
    "note": "鎖帳 = 該月唔准新增／沖銷（只可以喺下個月出調整分錄）—— 會計師月結用。",
    "audit_heading": "審計鏈驗算",
    "audit_cta": "驗算審計鏈",
    "audit_ok": "✅ 審計鏈完整（{{n}} 筆）",
    "audit_bad": "❌ 審計鏈斷咗：{{at}}（{{reason}}）",
    "audit_note": "每筆記錄嘅 hash 都包含前筆 hash → 改任何一筆，之後全部驗唔過（可偵測、可舉證）。"
  },
  "profit": {
    "heading": "淨利分配試算",
    "all_entities": "合併（兩間公司）",
    "ai85_pct": "85 AI 佔幾 %",
    "parties": "85% 各 party（名:%）",
    "parties_hint": "例：Simon:60,Raymond:25（留空＝用設定／佔位）",
    "readonly_note": "本頁**只做試算，唔會過帳**（政策未拍板 —— 見 decisions/006）。可以即場改比例同名單。",
    "net": "淨利",
    "by_entity": "逐間公司",
    "allocation": "分配試算",
    "no_allocation": "淨利 ≤ 0 → 唔分配",
    "party": "party",
    "total": "合計",
    "posting_disabled": "⏳ 過帳（出分錄）要等產品負責人拍板：85% 各 party／每間獨立定合併／15% 實體轉移定帳面分配。"
  },
  "report": {
    "heading": "月報",
    "net": "淨額",
    "locked": "⚠️ 呢個月已鎖帳（唔准新增／修改；只可以下月出調整分錄）",
    "by_category_expense": "支出（按類別）",
    "by_category_income": "收入（按類別）",
    "by_paid_by": "按邊個付錢",
    "by_method": "按付款方式",
    "by_project": "按項目",
    "by_month": "按月（未揀月份）",
    "reimb": "代墊待補回",
    "reimb_none": "冇代墊待補回 ✅",
    "reimb_pending": "待補回 {{amount}}（{{n}} 筆）",
    "reimb_settled": "已補回 {{amount}}"
  },
  "export": {
    "heading": "匯出",
    "mode": "範圍",
    "mode_month": "按月",
    "mode_range": "按日期範圍",
    "from": "由",
    "to": "到",
    "xlsx_cta": "⬇️ 下載 Excel",
    "pack_cta": "🗂️ 下載憑證包 ZIP",
    "xlsx_what": "Excel 四張表：交易明細／月結小計／科目彙總／代墊待補回",
    "pack_what": "憑證包：Excel ＋ 單據影像（檔名＝憑單號）＋ manifest.csv（含 sha256）",
    "note": "兩個檔案都經登入驗證下載（唔會公開）。交俾會計師可以直接 audit。"
  },
  "bank": {
    "heading": "銀行對帳",
    "entity": "公司",
    "account": "銀行／現金戶口",
    "sync_meta": "戶口清單跟公司主檔（`meta.accounts`）；如要加戶口請先喺主檔加。",
    "status": "狀態",
    "status_all": "全部",
    "status_unmatched": "未配對",
    "status_matched": "已配對",
    "status_ignored": "已忽略",
    "import_heading": "匯入月結單（CSV／TSV）",
    "import_hint": "喺銀行網站／App 匯出 CSV（或 Excel 另存 CSV）→ 開檔複製 → 貼落下面。要有標題列（日期＋金額 或 存入／支出）。",
    "import_cta": "匯入並去重",
    "csv_needed": "請先貼上 CSV 內容",
    "imported": "✅ 已匯入 {{imported}} 行，跳過重複 {{skipped}} 行",
    "import_errors": "⚠️ 有 {{n}} 行解析唔到（唔會靜默掉，見下面）",
    "line_count": "共 {{n}} 行",
    "txn_date": "交易日期",
    "description": "摘要",
    "amount": "金額",
    "direction_in": "存入",
    "direction_out": "支出",
    "suggestions": "配對建議",
    "no_suggestion": "冇自動建議（可先去記帳，或用「忽略」）",
    "match": "配對",
    "matched": "✅ 已配對：{{no}}",
    "ignore": "忽略",
    "ignore_reason": "忽略原因",
    "ignore_reason_hint": "例：銀行手續費未入帳",
    "ignore_cta": "確認忽略",
    "ignored": "已忽略：{{reason}}",
    "reason_needed": "請填忽略原因（≥3 字）",
    "all_done": "呢一行已經處理過",
    "report_heading": "對帳報告",
    "statement_closing": "月結單期末餘額",
    "statement_source": "來源：{{src}}",
    "book_balance": "帳簿餘額（該戶口）",
    "difference": "差額（月結單 − 帳簿）",
    "unmatched_statement": "未配對月結單行（{{n}}）",
    "unmatched_book": "未配對帳簿行（{{n}}）",
    "net": "淨額",
    "empty": "暫無資料",
    "explain": "差額 ＝ 兩邊未配對項目嘅淨額（＝要解釋嘅嘢：未入帳／未過數／手續費…）。對帳唔會改帳。",
    "voucher": "憑單"
  },
  "dist": {
    "heading": "淨利分配過帳（P2-2；政策已拍板）",
    "entity": "公司",
    "period": "期間（要已鎖帳）",
    "coleadery_pct": "CoLeadery %（10–20）",
    "marketing_pct": "市場推廣特別帳 %（40–50）",
    "note": "政策（已拍板）：醫療基金 15%／CoLeadery 20%／CoLinkery 10%／市場推廣特別帳 40%（合共 85%）＋ 85 AI Technology 15%。CoLeadery（10–20%）同市場推廣（40–50%）可以逐次改，但兩者相加必須 ＝ 60%（五項合計 ＝ 100%）。",
    "preview": "試算（唔改帳）",
    "income": "收入",
    "expense": "支出",
    "net": "淨利",
    "locked": "✅ 已鎖帳（可以過帳）",
    "not_locked": "⚠️ 未鎖帳（唔准過帳）",
    "target": "分配對象",
    "code": "科目",
    "amount": "金額",
    "total": "合計",
    "from_retained": "（撥自留存收益）",
    "already": "⚠️ 呢一期已經分配過帳過（{{amount}}）—— 一期一次；要更正請紅字沖銷該期憑單。",
    "loss": "⚠️ 淨利 ≤ 0（虧損）→ 唔分配。",
    "post": "確認過帳（出 JV 憑單）",
    "posted": "✅ 已過帳 {{no}}：{{amount}}",
    "post_note": "過帳 ＝ 一張 JV：Dr 留存收益 ／ Cr 五個對象（逐項一筆，Σ ＝ 淨利）。⚠️ 分配係權益撥帳 —— **唔會出現喺損益表**。",
    "history": "分配紀錄",
    "base_net": "分配基礎（淨利）"
  },
  "assets": {
    "heading": "固定資產（折舊）",
    "entity": "公司",
    "status": "狀態",
    "status_active": "使用中",
    "status_disposed": "已處置",
    "status_all": "全部",
    "count": "使用中 {{n}} 項",
    "cost": "成本",
    "accumulated": "累計折舊",
    "book_value": "帳面淨值",
    "monthly": "每月",
    "this_period": "今期折舊",
    "total": "合計",
    "remaining_months": "剩 {{n}} 期",
    "create_heading": "新增資產",
    "name": "資產名",
    "name_hint": "例：MacBook Pro M4（設計用）",
    "category": "分類",
    "acquired_date": "購入日",
    "salvage": "殘值",
    "life_months": "使用年期（月）",
    "create": "新增資產（自動編號 FA-YYYY-MM-####）",
    "created": "✅ 已新增資產",
    "form_note": "直線法：每月折舊 ＝（成本 − 殘值）÷ 年期月數；最後一期補足差額（Σ 折舊 ＝ 成本 − 殘值）。購入當月開始計。",
    "dep_heading": "每月折舊（一個期間一張憑單）",
    "period": "期間",
    "preview": "試算（唔改帳）",
    "post": "確認過帳（出 JV 憑單）",
    "posted": "✅ 已過帳 {{no}}：{{amount}}（{{n}} 項資產）",
    "already_posted": "⚠️ 呢個期間已經過帳過（{{no}}）—— 一個期間只可以過一次；要更正請紅字沖銷該期憑單。",
    "nothing": "呢個期間冇需要折舊嘅資產（未購入／已折舊完／已處置）→ 唔會出空憑單。",
    "post_note": "過帳 ＝ 出一張 JV：Dr 5210 折舊費用／Cr 1390 累計折舊（逐項資產一對 line，可追溯）。折舊係費用（影響 85:15 分配），但唔涉及現金。",
    "list_heading": "資產清單",
    "asset_no": "資產編號",
    "proceeds": "處置價",
    "dispose": "處置（出售／報廢）",
    "disposed": "✅ 已處置 {{no}}：帳面淨值 {{book}}、收益 {{gain}}",
    "runs": "折舊過帳紀錄",
    "run_detail": "{{n}} 項資產"
  }
}
